import { Component, Input, Output, EventEmitter } from "@angular/core";

import {
  User,
  Invite,
  InviteListConfig,
} from "../../../../../../shared/models";
import { InviteListResult } from "../../../../../../shared/interfaces";
import { InviteService } from "../../../../../../shared/services";

/*
  config.type are either sent or received
  targetModel is either Community or Discussion
  sender or recipient can also be specified                    
*/

@Component({
  selector: "invite-notification-list",
  templateUrl: "./invite-notification-list.component.html",
  styleUrls: [
    "./invite-notification-list.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class InviteNotificationListComponent {
  constructor(private inviteService: InviteService) {}

  private query: InviteListConfig;
  public results: Invite[];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;
  public totalCount: number;

  @Output() confirmAlert = new EventEmitter<any>();
  @Input() limit: number;
  @Input() currentUser: User;
  @Input() liveInvite: string;
  @Input()
  set config(config: InviteListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.runQuery();
    }
  }

  public updateLoading(status) {
    this.loading = status;
  }

  public updateInvites(inviteObj) {
    const inviteIndex = this.results.findIndex(
      (invite) => invite.id === inviteObj.inviteId
    );
    this.results[inviteIndex].status = inviteObj.status;
  }

  public fetchUserInvites() {
    this.inviteService
      .findMany(this.currentUser.username, this.query)
      .subscribe((data: InviteListResult) => {
        this.results = data.invites;
        this.totalCount = data.inviteCount.total;
        this.totalPages = data.pages.total;
        this.confirmAlert.emit(data.invites.length > 0);
        this.loading = false;
      });
  }

  public runQuery() {
    this.loading = true;
    this.results = [];

    if (this.limit) {
      this.query.limit = this.limit;
      this.query.offset = this.limit * (this.currentPage - 1);
    }

    this.fetchUserInvites();
    window.scroll(0, 0);
  }

  public setPageTo(pageNumber: number) {
    this.currentPage = pageNumber;
    this.runQuery();
  }
}
